<template>
  <div>
    <v-card class="pa-2 ma-0 flex-grow-1">
      <v-card-title>
        <v-row class="ma-0 pa-0">
          <v-col
            cols="12"
            class="d-flex justify-center pa-0"
            @click="$emit('click')"
          >
            <v-chip color="primary" style="cursor:pointer">
              <span class="text-truncate">
                {{ planName }}
              </span>
            </v-chip>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" class="pl-0 pr-0">
            {{ $t("globals.effective_date") }}:
            {{
              planConfiguration.EffectiveDate &&
                planConfiguration.EffectiveDate.slice(0, 10)
            }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-row class="ma-0 mt-2 pa-0">
          <span class="minfo">
            {{ $t("enums.Dental") }}
          </span>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="planConfiguration.PlanBenefitsCategoriesDental.length > 0">
          <v-col
            cols="12"
            sm="6"
            v-for="category in planConfiguration.PlanBenefitsCategoriesDental"
            :key="category"
            class="pa-0"
          >
            {{ category }}
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" v-else>
          <v-col
            cols="12"
            sm="6"
            class="pa-0"
          >
            {{ $t("components.plan_benefit_rules.plan_tile.no_categories") }}
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
          <span class="minfo">
            {{ $t("enums.Health") }}
          </span>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="planConfiguration.PlanBenefitsCategoriesHealth.length > 0">
          <v-col
            cols="12"
            sm="6"
            v-for="category in planConfiguration.PlanBenefitsCategoriesHealth"
            :key="category"
            class="pa-0"
          >
            {{ category }}
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" v-else>
          <v-col
            cols="12"
            sm="6"
            class="pa-0"
          >
            {{ $t("components.plan_benefit_rules.plan_tile.no_categories") }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="deleteDialog = true" color="error">
          <v-icon>
            delete
          </v-icon>
          {{ $t("globals.delete") }}
        </v-btn>
        <v-btn @click="$emit('click')" color="primary">
          <v-icon>
            visibility
          </v-icon>
          {{ $t("globals.view_details") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <delete-configuration-dialog
      :configuration="planConfiguration"
      :model="deleteDialog"
      @deleted="
        deleteDialog = false;
        $emit('deleted');
      "
      @close="deleteDialog = false"
    />
  </div>
</template>

<script>
import DeleteConfigurationDialog from "./DeleteConfigurationDialog.vue";
export default {
  props: [
    "planConfiguration",
    "planName",
    // "healthBenefitCategories",
    // "dentalBenefitCategories",
  ],
  components: {
    DeleteConfigurationDialog,
  },
  data() {
    return {
      deleteDialog: false,
    };
  },
  mounted() {
    console.log(this.planName);
  },
  methods: {},
};
</script>

<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
.v-card__title {
  padding: 0 !important;
  position: relative;
  display: block;
}
.v-card__title .v-chip {
  font-weight: 300;
  display: block;
}
</style>
